import React from 'react';
import LandingView from 'landing/components/landingView';
import useLanding from 'landing/components/landingView/useLanding';
import { useTheme } from '../../shared/hooks';

const Landing = () => {
  const { landingData, location } = useLanding();

  const { theme } = useTheme();

  return (
    <LandingView
      routerState={location.state}
      landingData={landingData}
      theme={theme}
    />
  );
};

export default Landing;
